<app-modal-header title="Set up two-factor authentication" />

<form class="modal-form" (ngSubmit)="verify()" novalidate>
  <app-modal-body>
    @if (loadError()) {
      <p class="form-error" role="alert">{{ loadError() }}</p>
    } @else if (setup(); as s) {
      <div class="two-factor-setup">
        <p class="two-factor-setup__hint">Scan this code with an authenticator app (Google Authenticator, 1Password, Authy…).</p>
        <div class="two-factor-setup__qr">
          <qrcode [qrdata]="s.otpauthUri" [width]="180" errorCorrectionLevel="M"></qrcode>
        </div>
        <button type="button" class="link two-factor-setup__toggle" (click)="showSecret.set(!showSecret())">
          {{ showSecret() ? 'Hide the code' : "Can't scan it?" }}
        </button>
        @if (showSecret()) {
          <code class="two-factor-setup__secret">{{ s.secret }}</code>
        }

        <div class="form-field">
          <label class="form-field__label" for="tfa-code">6-digit code</label>
          <input
            id="tfa-code"
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
            class="field-input field-input--text otp-input"
            [formControl]="code"
            placeholder="000000"
            data-modal-autofocus
          />
          @if (code.invalid && code.touched) {
            <p class="form-field__error">Enter the 6-digit code from your authenticator app.</p>
          }
          @if (verifyError()) {
            <p class="form-field__error" role="alert">{{ verifyError() }}</p>
          }
        </div>
      </div>
    } @else {
      <div class="two-factor-setup" aria-live="polite">
        <app-skeleton width="212px" height="212px" radius="8px"></app-skeleton>
        <p class="two-factor-setup__hint">Setting up…</p>
      </div>
    }
  </app-modal-body>

  <app-modal-footer>
    <button type="button" class="btn--secondary" [disabled]="verifying()" (click)="modalRef.dismiss()">Cancel</button>
    @if (loadError()) {
      <button type="button" class="btn--primary" (click)="loadSetup()">Try again</button>
    } @else {
      <button type="submit" class="btn--primary" [disabled]="!setup() || verifying()">
        {{ verifying() ? 'Verifying…' : 'Verify & enable' }}
      </button>
    }
  </app-modal-footer>
</form>
